import React, { createContext, useState, ReactNode } from 'react';

import { DisplayNotification } from '../models/DisplayNotification';
import { GlobalLoadingContextType } from './types/globalLoadingContextType';
import LoadingIndicator from '../components/common/LoadingIndicator';


export const GlobalLoadingContext = createContext<GlobalLoadingContextType | undefined>(undefined);

export const GlobalLoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [loading, setLoading] = useState<boolean>(false);



    return (
        <GlobalLoadingContext.Provider value={{
            loading,
            setLoading
        }}>
            {children}
            {loading && <LoadingSpinner />}
        </GlobalLoadingContext.Provider>
    );
};

const LoadingSpinner: React.FC = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-50 z-50">
            <div className="loader border-t-transparent border-solid rounded-full border-4 border-primary w-16 h-16 animate-spin"></div>
        </div>
    );
};
